import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const DEFAULT_SORT = (type) => {
	if (type === 'SUPPLIER_LIST') return { value: 'Supplier Ranking' };
	if (type === 'POM_LIST') return { value: 'Serial' };
	return { value: 'Newest' };
};

const Sort = ({ title, removedLastModified = false, sortKeyWord = 'id' }) => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, 'sort', 'sort') || DEFAULT_SORT(title);
	const dispatch = useDispatch();

	const getPomListPageSorting = (value) => {
		if (value === 'Serial') return `serial`;
		else if (value === 'TBO') return `parentCategory`;
		else if (value === 'Body Parts') return `bodyPart`;
		else if (value === 'Position') return `position`;
		else if (value === 'POM Size') return `size`;
		else if (value === 'Side') return `side`;
	};

	const getSupplierListPageSorting = (value) => {
		if (value === 'Supplier Ranking') return `gradingMark,desc`;
		else if (value === 'Status') return `supplierStatus,asc`;
		else if (value === 'Recently added') return `id,desc`;
	};

	const getPageWiseSortType = (value) => {
		if (title === 'Collection') return 'lastDesignUpdatedAt,desc';
		else if (title === 'SUPPLIER_LIST') return getSupplierListPageSorting(value);
		else if (title === 'POM_LIST') return getPomListPageSorting(value);
		else return 'lastResponseTime,desc';
	};

	const getKeyName = (value) => {
		if (value === 'Newest') return `${sortKeyWord},desc`;
		else if (value === 'Oldest') return `${sortKeyWord},asc`;
		else return getPageWiseSortType(value);
	};

	const handleChange = (e) => {
		let { value, name } = e.target;
		let data = {
			name: 'sort',
			type: 'text',
			key: getKeyName(value),
			value: value,
			identifier: name
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<div className="sort-button">
			<select name="sort" id className="border-0" onChange={handleChange}>
				{title === 'SUPPLIER_LIST' ? (
					<>
						<option
							value={'Supplier Ranking'}
							selected={inputValue?.value === 'Supplier Ranking'}
						>
							Supplier Ranking
						</option>
						<option value={'Status'} selected={inputValue?.value === 'Status'}>
							Status
						</option>
						<option value={'Recently added'} selected={inputValue?.value === 'Recently added'}>
							Recently added
						</option>
					</>
				) : title === 'POM_LIST' ? (
					<>
						<option value={'Serial'} selected={inputValue?.value === 'Serial'}>
							Serial-wise
						</option>
						<option value={'Newest'} selected={inputValue?.value === 'Newest'}>
							Newest first
						</option>
						<option value={'Oldest'} selected={inputValue?.value === 'Oldest'}>
							Oldest first
						</option>

						<option value={'TBO'} selected={inputValue?.value === 'TBO'}>
							TBO
						</option>
						<option value={'Body Parts'} selected={inputValue?.value === 'Body Parts'}>
							Body Parts
						</option>
						<option value={'Position'} selected={inputValue?.value === 'Position'}>
							Position
						</option>
						<option value={'POM Size'} selected={inputValue?.value === 'POM Size'}>
							POM Size
						</option>
						<option value={'Side'} selected={inputValue?.value === 'Side'}>
							Side
						</option>
					</>
				) : (
					<>
						<option value={'Newest'} selected={inputValue?.value === 'Newest'}>
							Newest first
						</option>
						<option value={'Oldest'} selected={inputValue?.value === 'Oldest'}>
							Oldest first
						</option>
						{!removedLastModified && (
							<option value={'Last Modified'} selected={inputValue?.value === 'Last Modified'}>
								Last modified
							</option>
						)}
					</>
				)}
			</select>
		</div>
	);
};

export default Sort;
